var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { css, StyleSheet } from 'aphrodite';
import { stylePropType, childrenPropType, TSS_BLACK } from 'tss-core-lib-common';
import Levitate from './Levitate';

var styles = void 0;

var Tooltip = function (_Component) {
  _inherits(Tooltip, _Component);

  function Tooltip(props) {
    _classCallCheck(this, Tooltip);

    var _this = _possibleConstructorReturn(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call(this, props));

    _this.setAnchorRef = function (ref) {
      _this.ref = ref;
      _this.checkTarget();
    };

    _this.handleScroll = function () {
      requestAnimationFrame(function () {
        return _this.forceUpdate(function () {
          _this.dirty = false;
        });
      }, 1);
      _this.dirty = true;
    };

    _this.handleMouseEnter = function () {
      _this.dirty = true;
      _this.setState({ disabled: false }, function () {
        _this.dirty = false;
      });
    };

    _this.handleMouseLeave = function () {
      _this.dirty = true;
      _this.setState({ disabled: true }, function () {
        _this.dirty = false;
      });
    };

    _this.state = {
      target: null,
      disabled: !props.static
    };
    return _this;
  }

  _createClass(Tooltip, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var main = document.getElementById('main');
      if (main) {
        main.addEventListener('scroll', this.handleScroll);
      }
      this.checkTarget();
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return this.dirty !== false;
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate() {
      var _this2 = this;

      if (!this.dirty) {
        clearTimeout(this.timer);
        this.timer = setTimeout(function () {
          return _this2.forceUpdate(function () {
            _this2.dirty = false;
          });
        }, 1);
      }
      this.dirty = true;
      this.checkTarget();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var main = document.getElementById('main');
      if (main) {
        main.removeEventListener('scroll', this.handleScroll);
      }
      if (this.state.target && !this.props.static) {
        this.state.target.removeEventListener('mouseenter', this.handleMouseEnter);
        this.state.target.removeEventListener('mouseleave', this.handleMouseLeave);
      }
    }
  }, {
    key: 'checkTarget',
    value: function checkTarget() {
      if (this.ref && (!this.state.target || this.state.target !== this.ref.parentElement)) {
        if (this.state.target && !this.props.static) {
          this.state.target.removeEventListener('mouseenter', this.handleMouseEnter);
          this.state.target.removeEventListener('mouseleave', this.handleMouseLeave);
        }
        if (this.ref.parentElement) {
          if (!this.props.static) {
            this.ref.parentElement.addEventListener('mouseenter', this.handleMouseEnter);
            this.ref.parentElement.addEventListener('mouseleave', this.handleMouseLeave);
          }

          this.setState({
            target: this.ref.parentElement
          });
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          left = _props.left,
          right = _props.right,
          below = _props.below;

      var disabled = this.state.disabled;
      var dim = 600;
      var style = { width: dim, height: dim };

      var above = !left && !right && !below;

      try {
        if (this.state.target) {
          var rect = this.state.target.getBoundingClientRect();

          if (left || right) {
            style.top = rect.top - dim / 2 + rect.height / 2;
          } else {
            // Default is above
            style.left = rect.left - dim / 2 + rect.width / 2;
          }

          if (below) {
            style.top = rect.bottom;
          } else if (right) {
            style.left = rect.right;
          } else if (left) {
            style.left = rect.left - dim;
          } else {
            // Default is above
            style.top = rect.top - dim;
          }
        }
      } catch (e) {
        console.error(e);
        disabled = true;
      }

      style.top += document.documentElement && document.documentElement.scrollTop || document.body.scrollTop;

      return [!disabled ? React.createElement(
        Levitate,
        { key: 'tooltip' },
        React.createElement(
          'div',
          {
            className: css(styles.container, above && styles.containerAbove, below && styles.containerBelow, left && styles.containerLeft, right && styles.containerRight),
            style: style
          },
          React.createElement(
            'div',
            {
              className: css(styles.inner, above && styles.innerAbove, below && styles.innerBelow, left && styles.innerLeft, right && styles.innerRight)
            },
            React.createElement(
              'div',
              { className: css(styles.content, this.props.style) },
              this.props.children
            ),
            React.createElement('span', {
              className: css(styles.arrow, above && styles.arrowBelow, below && styles.arrowAbove, left && styles.arrowRight, right && styles.arrowLeft)
            })
          )
        )
      ) : null, React.createElement('div', { key: 'anchor', ref: this.setAnchorRef })];
    }
  }]);

  return Tooltip;
}(Component);

Tooltip.propTypes = {
  children: childrenPropType.isRequired,
  above: PropTypes.bool,
  left: PropTypes.bool,
  right: PropTypes.bool,
  below: PropTypes.bool,
  static: PropTypes.bool,
  style: stylePropType
};
Tooltip.defaultProps = {
  above: false,
  left: false,
  right: false,
  below: false,
  static: false,
  style: null
};


styles = StyleSheet.create({
  container: {
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    pointerEvents: 'all'
  },

  containerAbove: {
    alignItems: 'flex-end'
  },

  containerBelow: {
    alignItems: 'flex-start'
  },

  containerLeft: {
    justifyContent: 'flex-end'
  },

  containerRight: {
    justifyContent: 'flex-start'
  },

  inner: {
    position: 'relative',
    border: 0,
    backgroundColor: TSS_BLACK(),
    minWidth: '20rem',
    maxWidth: '30rem',
    color: 'white',
    fontSize: '1.4rem',
    textAlign: 'center'
  },

  content: {
    padding: '1rem'
  },

  innerAbove: {
    marginBottom: 10
  },

  innerBelow: {
    marginTop: 10
  },

  innerLeft: {
    marginRight: 10
  },

  innerRight: {
    marginLeft: 10
  },

  arrow: {
    position: 'absolute',
    border: 'solid transparent',
    height: 0,
    width: 0,
    pointerEvents: 'none',
    borderColor: TSS_BLACK(0)
  },

  arrowBelow: {
    top: '100%',
    left: '50%',
    borderTopColor: TSS_BLACK(),
    borderWidth: '8px',
    marginLeft: '-8px'
  },

  arrowAbove: {
    bottom: '100%',
    left: '50%',
    borderBottomColor: TSS_BLACK(),
    borderWidth: '8px',
    marginLeft: '-8px'
  },

  arrowLeft: {
    right: '100%',
    top: '50%',
    borderRightColor: TSS_BLACK(),
    borderWidth: '8px',
    marginTop: '-8px'
  },

  arrowRight: {
    left: '100%',
    top: '50%',
    borderLeftColor: TSS_BLACK(),
    borderWidth: '8px',
    marginTop: '-8px'
  }
});

export default Tooltip;